import { lazy } from 'react';
import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";

const Home = lazy(() => import("@/pages/home/page"));
const AboutPage = lazy(() => import("@/pages/about/page"));
const ServicesPage = lazy(() => import("@/pages/services/page"));
const ReferencesPage = lazy(() => import("@/pages/references/page"));
const FAQPage = lazy(() => import("@/pages/faq/page"));
const ContactPage = lazy(() => import("@/pages/contact/page"));
const KvkkPage = lazy(() => import("@/pages/kvkk/page"));
const CerezPolitikasiPage = lazy(() => import("@/pages/cerez-politikasi/page"));
const BlogPage = lazy(() => import("@/pages/blog/page"));
const BlogDetailPage = lazy(() => import("@/pages/blog/BlogDetail"));
const KasetliTentePage = lazy(() => import("@/pages/services/kasetli-tente/page"));
const KorukluTentePage = lazy(() => import("@/pages/services/koruklu-tente/page"));
const MafsalliTentePage = lazy(() => import("@/pages/services/mafsalli-tente/page"));
const TModelTentePage = lazy(() => import("@/pages/services/t-model-tente/page"));
const WinTentePage = lazy(() => import("@/pages/services/win-tente/page"));
const BioklimatikPergolaPage = lazy(() => import("@/pages/services/bioklimatik-pergola/page"));
const OtomatikPergolaPage = lazy(() => import("@/pages/services/otomatik-pergola/page"));
const RollingroofPergolaPage = lazy(() => import("@/pages/services/rollingroof-pergola/page"));
const SeffafBrandaPage = lazy(() => import("@/pages/services/seffaf-branda/page"));
const SeffafStorBrandaPage = lazy(() => import("@/pages/services/seffaf-stor-branda/page"));
const ZipPerdePage = lazy(() => import("@/pages/services/zip-perde/page"));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/hakkimizda", element: <AboutPage /> },
  { path: "/hizmetler", element: <ServicesPage /> },
  { path: "/hizmetler/kasetli-tente", element: <KasetliTentePage /> },
  { path: "/hizmetler/koruklu-tente", element: <KorukluTentePage /> },
  { path: "/hizmetler/mafsalli-tente", element: <MafsalliTentePage /> },
  { path: "/hizmetler/t-model-tente", element: <TModelTentePage /> },
  { path: "/hizmetler/win-tente", element: <WinTentePage /> },
  { path: "/hizmetler/bioklimatik-pergola", element: <BioklimatikPergolaPage /> },
  { path: "/hizmetler/otomatik-pergola", element: <OtomatikPergolaPage /> },
  { path: "/hizmetler/rollingroof-pergola", element: <RollingroofPergolaPage /> },
  { path: "/hizmetler/seffaf-branda", element: <SeffafBrandaPage /> },
  { path: "/hizmetler/seffaf-stor-branda", element: <SeffafStorBrandaPage /> },
  { path: "/hizmetler/zip-perde", element: <ZipPerdePage /> },
  { path: "/referanslar", element: <ReferencesPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogDetailPage /> },
  { path: "/sss", element: <FAQPage /> },
  { path: "/iletisim", element: <ContactPage /> },
  { path: "/kvkk", element: <KvkkPage /> },
  { path: "/cerez-politikasi", element: <CerezPolitikasiPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
